import { Card } from "@mui/material";
import { Cols } from "../../shared/Consts";
import Holding from "../../models/Holding";
import KeyVal from "../../components/KeyVal";

export default function SummaryCash(props:{holding:Holding,openBalance:string,closeBalance:string}) {
    return <Card className="historySummary">
        <KeyVal label="Total" value={props.holding.value(Cols.holdingValue)}/>
        <KeyVal label="Dividend" value={props.holding.value(Cols.dividend)}/>
        <KeyVal label="Open Balance" value={props.openBalance}/>
        <KeyVal label="Close Balance" value={props.closeBalance}/>
    </Card>
}
